import { useState } from 'react';
import api from '../config/api';

const useImageUpload = () => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);
  const [progress, setProgress] = useState([]); // Array of progresses for multiple images
  // const [uploadedUrl, setUploadedUrl] = useState(null);

  // const uploadImage = async (imageFile) => {
  //   if (!imageFile) {
  //     setError('No image file provided');
  //     return null;
  //   }

  //   setUploading(true);
  //   setError(null);
  //   setProgress(0);

  //   try {
  //     const formData = new FormData();
  //     formData.append('media', imageFile);

  //     const response = await api.post('/media-upload/upload', formData, {
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //       },
  //       onUploadProgress: (progressEvent) => {
  //         const percent = Math.round(
  //           (progressEvent.loaded * 100) / progressEvent.total
  //         );
  //         setProgress(percent);
  //       },
  //     });
  //     console.log(response)
  //     const imageUrl = response.data?.data?.url || response.data?.data?.image_url;

  //     setUploadedUrl(imageUrl);
  //     setProgress(100);
  //     setUploading(false);

  //     return imageUrl;
  //   } catch (err) {
  //     setUploading(false);
  //     setError(err.response?.data?.message || 'Upload failed');
  //     return null;
  //   }
  // };

  const uploadMultipleImages = async (imageFiles) => {
    if (!imageFiles || imageFiles.length === 0) {
      setError('No image files provided');
      return [];
    }

    setUploading(true);
    setError(null);
    setProgress(new Array(imageFiles.length).fill(0)); // Initialize progress array

    try {
      const uploadPromises = imageFiles.map(async (imageFile, index) => {
        const formData = new FormData();
        formData.append('media', imageFile);

        const response = await api.post('/media-upload/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            
            // Update progress for specific image
            setProgress(prev => {
              const newProgress = [...prev];
              newProgress[index] = percent;
              return newProgress;
            });
          },
        });

        const imageUrl = response.data?.data?.url || response.data?.data?.image_url;
        return imageUrl;
      });

      const imageUrls = await Promise.all(uploadPromises);
      
      // Set all progress to 100 when complete
      setProgress(new Array(imageFiles.length).fill(100));
      setUploading(false);
      
      return imageUrls;
    } catch (err) {
      setUploading(false);
      setError(err.response?.data?.message || 'Upload failed');
      return [];
    }
  };
  return {
    // uploadImage,
    uploadMultipleImages,
    uploading,
    error,
    progress,
    // uploadedUrl,
  };
};

export default useImageUpload;
